// Mock data for Ragnarok Energy products

export const products = [
{
  id: 1,
  name: "Classic",
  tagline: "Original Energy Formula",
  color: "#FFD700",
  accentColor: "#FFA500",
  image: "https://customer-assets.emergentagent.com/job_a548ea69-4ae3-4fdc-a809-179eb0171f37/artifacts/xx2qoy0q_combine_these_in_202604141650.png",
  description: "The original energy experience"
},
{
  id: 2,
  name: "Zero Sugar",
  tagline: "Pure Energy, Zero Compromise",
  color: "#E8E8E8",
  accentColor: "#333333",
  image: "https://customer-assets.emergentagent.com/job_a548ea69-4ae3-4fdc-a809-179eb0171f37/artifacts/xx2qoy0q_combine_these_in_202604141650.png",
  description: "All the power, none of the sugar"
},
{
  id: 3,
  name: "Ultra Max",
  tagline: "Maximum Power Unleashed",
  color: "#8B0000",
  accentColor: "#DC143C",
  image: "https://customer-assets.emergentagent.com/job_a548ea69-4ae3-4fdc-a809-179eb0171f37/artifacts/xx2qoy0q_combine_these_in_202604141650.png",
  description: "The ultimate energy experience"
}];


export const brandInfo = {
  name: "Ragnarok Energy",
  tagline: "Rage of the Wolf Power of Ragnarok",
  subtitle: "Unleash the Wolf",
  description: "Ragnarok Energy is built for those who refuse to stay ordinary. Designed to fuel intensity, focus, and raw power.",
  instagram: "ragnarok_energy_drink"
};